export const FilterTypes = {
    search: 'search',
    year: 'yearSearch',
    select: 'select',
    multiSelect: 'multiSelect',
    toggle: 'toggle',
    selectByEnum: 'selectByEnum',
    
}